<template>
<div>


  
    <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />

     <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/> 


<div v-if="card == 'A'">

  <printZebraModal :key="refreshZPL" v-bind:data='data'></printZebraModal> 
  <print-epl-modal :key="refreshEPL" v-bind:data='data'></print-epl-modal> 

  <div v-if="type=='confirm'" class="form-group form-check ml-3">
              <input @change="setData()" type="checkbox" class="form-check-input" id="exampleCheck1" v-model="productsToConfirm">
              <label class="form-check-label" for="exampleCheck1"><strong>MOSTRA SOLTANTO PRODOTTI DA CONSEGNARE</strong></label>
            </div>

  <div class="table-wrapper-scroll-y my-custom-scrollbar mt-1">

  <table class="table table-bordered table-hover table-striped table-sm mb-0">
    <thead class="table-primary">
      <tr>
        <th colspan="18">

            <h4 class="text-center mt-4" style="color:black"><strong>LISTA PRODOTTI</strong><span class="editOrder ml-4" v-if="type!='confirm' && items.length > 0"> ( doppio click modifica ordine )</span></h4>
           


        </th>
      </tr>  
      <tr>

        <th scope="col">#</th>
        <th scope="col"></th>
        <th scope="col"></th>
        <th scope="col"></th>
        <th v-if="printLabels" scope="col"></th>
        <th scope="col">ID PRODOTTO</th>
        <th scope="col">CODICE</th>
        <th scope="col">BRAND</th>
        <th scope="col">CATEGORIA</th>
        <th scope="col">DESCRIZIONE</th>
        <th scope="col">REPARTO</th>
        <th scope="col">STAGIONE</th>
        <th scope="col">DATA</th>
        <th class="text-right" scope="col">ORDINATO</th>
        <th class="text-right" scope="col">CONSEGNATO</th>
        <th class="text-right" scope="col">COSTO UNITARIO €</th>
        <th class="text-right" scope="col">SCONTO %</th>
        <th class="text-right" scope="col">TOTALE €</th>
        
       
      </tr>
    </thead>
    <tbody>

      <tr data-toggle="tooltip" title="doppio click seleziona prodotto" class="pointer hover-row" v-on:dblclick="setProductDetail(item)" v-for="(item, index) in filteredItems" :key="index">
        <td>{{index+1}}</td> 
      <td>
        <a @click="deleteBox(item.productId,index)"><i style="color:#996633;" data-toggle="tooltip" title="Elimina riga"  class="fa fa-trash" aria-hidden="true"></i></a>    
      </td> 
      
      <td>
        <a @click="setDetail(item,index)"><i style="color:#736AFF;" data-toggle="tooltip" title="Mostra dettaglio "  class="fa fa-database" aria-hidden="true"></i></a>    
      </td> 
      <td>
          <a @click="setEditProduct(item)"><i style="color:brown;" data-toggle="tooltip" title="Modifica anagrafica"  class="fa fa-edit" aria-hidden="true"></i></a>    
      </td> 
      <td v-if="printLabels">

        <div class="dropdown">
            <button style="color:black;background-color: white;" class="btn btn-info dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
            <i class="fas fa-print mr-2" aria-hidden="true"></i>
            STAMPA ETICHETTE
          </button>
          <div class="dropdown-menu border border-primary">
            <a  data-toggle="tooltip" title="" class="dropdown-item" @click="printModal(item,0)"  href="#">
                <i style="color:rgb(217, 37, 37)" class="fas fa-pallet mr-2" aria-hidden="true"></i>
                Tutto il consegnato 
            </a>
            <a data-toggle="tooltip" title="" class="dropdown-item" @click="printModal(item,1)"   href="#">
                <i style="color:green" class="	fas fa-boxes mr-2" aria-hidden="true"></i>
                Ultima consegna 
            </a>
            <a data-toggle="tooltip" title="" class="dropdown-item" @click="printModal(item,2)"   href="#">
                <i style="color:blue" class="fas fa-th mr-2" aria-hidden="true"></i>
                Tutto  lo stock disponibile
            </a>
            
            </div>
        </div>              
      </td> 
      
        
        <td>{{item.productId}}</td>
        
        <td>{{item.sku}}
            <div>
                <span v-if="spinner1[index]" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> 
                <detail v-if="row[index]" :key="refresh" @finish='setSpinner' @close="close" v-bind:orderId="orderId" v-bind:productId="productId"></detail>                                          
            </div>
        </td>

        <td>{{item.brand}}</td>
        <td>{{item.category}}</td>
        <td>{{item.description}}</td>
        <td>{{item.department}}</td>
        <td>{{item.season}}-{{item.season_year}} </td>
        <td>{{item.create_at}} </td>
        <td class="text-right">{{item.order_qty}} </td>
        <td v-bind:style="{color:item.delivered_qty < item.order_qty ? 'red':'black'}" class="text-right">{{item.delivered_qty}} </td>
        <td class="text-right">{{fmt1(item.cost_price)}} </td>
        <td class="text-right">{{item.discount}} </td>
        <td class="text-right"><strong>{{fmt1(item.total)}}</strong> </td>
        
       
      </tr> 
    </tbody>
   
    <tfoot >
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td v-if="printLabels"></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>TOTALI</td>
        <td class="text-right" >{{total.total1}}</td>
        <td class="text-right" >{{total.total2}}</td>
        <td></td>
        <td></td>
        <td class="text-right" >{{fmt1(total.total3)}}</td>
      </tr>
    </tfoot>  
   
  </table>



</div>
<i style="color:navy" class="fas fa-filter mr-2" aria-hidden="true"></i>
<label style="color:black">Filtra </label>
<input class="form-control" type="text" name="query" v-model="filterKey">  



</div>

<div v-else>
  
  <div  class="card border-info mt-1 ml-1 mr-1 mb-1 border-warning shadow">
          <h4 class="card-header border-warning">
            <i class="far fa-edit mr-2" aria-hidden="true"></i>
            <strong style="color:brown">MODIFICA ANAGRAFICA PRODOTTO </strong></h4>
          <div class="card-body">

          <button @click="card='A'" class="btn btn-outline-secondary btn-block">      
            <i style="color:black" class="fas fa-reply mr-2" aria-hidden="true"></i>
            RITORNA ALLA LISTA PRODOTTI
          </button>
            <edit-product  v-bind:item="item" ></edit-product>
           
          </div>
  </div>
</div>  


</div>


</template>
<script>
import { mapGetters }    from 'vuex';

import detail            from '@/components/order/OrderProductDetail.vue';
import editProduct       from '@/components/backOffice/ready/tab/ProductUpdate.vue';
import api               from '@/api'
import printZebraModal   from '@/components/common/PrintZebraModal.vue';
import printEplModal     from '@/components/common/PrintJSPMModal.vue';
import fmt               from '@/components/mixins/fmt'
import modalMessage                from '@/components/modalDialog/ModalMessage.vue'         
import modalConfirm                from '@/components/modalDialog/ModalConfirm.vue'

export default {
  mixins:[fmt],
  components  : {detail,editProduct,printZebraModal,printEplModal,modalConfirm,modalMessage},
  props : ['orderId','type','printLabels'],
  data() {
    return {
    
    productsToConfirm   : false,          
    card                : 'A',
    filterKey           : '',  
    index           : 0, 
    row             : [],
    
    refresh         : 0,  
    items           : [],
    saved_items     : [],
      
          
      spinner1        : [],
      productId       : 0,
      item            : {},
      refreshEPL    : 0,
      refreshZPL    : 100,
      data          : []
     
      
    };
  },
  computed :{ 
    ...mapGetters(['company']),

    filteredItems : function () 
      {

        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items

        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     

    total :function()
    {
      var total = {total1:0,total2:0,total3:0}
     
      this.filteredItems.forEach(item=>{
        total.total1 += item.order_qty
        total.total2 += item.delivered_qty
        total.total3 += item.total
      })
      

      return total
    }
    
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
 async mounted() {
    await this.getData()
    if(this.type=='confirm')
    {
      const productsToConfirm  =  JSON.parse(localStorage.getItem("productsToConfirm"))
      this.productsToConfirm   =  productsToConfirm == 'YES' ? true : false
      this.setData()
    }
      
  },

  created() {
    
  },  
  methods: {

    setData()
    {
    
      if(this.productsToConfirm)
      {
        
        const items = this.items.filter(item => item.delivered_qty != item.order_qty)          
        this.items = items
        localStorage.setItem('productsToConfirm',JSON.stringify('YES'))
        
      }
      else

      {
        
        localStorage.setItem('productsToConfirm',JSON.stringify('NO'))
        this.items = this.saved_items  
        
      }
      
    },
    async printModal(item,type)
      {
        
        let lang = this.company.printer_type
        this.spinner = true  
        
        this.data = await this.getDataToPrint(item,type)
       
        this.spinner = false
        
        
        if(lang=='EPL')
        {
          this.refreshEPL++
          this.$nextTick(() => {
            $('#printEPLModal').modal({keyboard: false,backdrop:'static','show':true});
            })
        }
        else
        {
          this.refreshZPL++
          this.$nextTick(() => {
           $('#printZebraModal').modal({keyboard: false,backdrop:'static','show':true});
            
        })  
        }
        
      },

    setEditProduct(item)
    {
      this.item = item
      this.card = 'B'
      this.$emit('change')
      
    },
  
    async deleteBox(productId,index)
    {

       const msg =  this.items[index]['brand'] + ' ' +  this.items[index]['sku']  + ' ' + this.items[index]['category'] + '   ?'  
       const confirmed=  await this.$refs.confirmModal.show(
          'SI DESIDERA ELIMINARE IL PRODOTTO CON ID ' + productId + '\n\n' + msg,
          { title: 'CONFERMA ELIMINAZIONE' }
        )

        if (!confirmed) return  
        this.$refs.confirmModal.close()

        this.deleteProduct(productId)

    },

    async deleteProduct(productId)
    {
      
        const sp       = 'spDeleteProductFromOrder'
        const payload  = {'orderId' : this.orderId,productId ,sp}
      
        this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'})      
        try{

            const res = await api.post(payload)
        
            if (res.status !== 200) 
            {
                throw new Error(res.data ||  res)
            }
            this.$refs.msgModal.close()
            this.getData()  
          }
        catch(err){

            
            const msg = err.message
            this.$refs.msgModal.show(msg)

        }





       
      
    },  







    setSpinner()
    {
        this.spinner1 = []
    },  
    close()
    {
        this.row      = []
    },
    setDetail(item,index)
    {

      if( this.row[index]==true)
      {
        return
      }
      this.spinner1        = []
      this.spinner1[index] = true
      this.row             = []
      this.row[index]      = true
      this.productId       = item.productId
      //this.refresh++
      
    },
    async setProductDetail(item)
    {  
        

        
        this.$emit('update',0)

        if(item.delivered_qty >= item.order_qty && this.type=='confirm')
        {
          
                    
          const msg = 'PRODOTTO ID [' + item.productId + '] \n' + item.sku + ' - ' + item.category +  '\nGIA\' CONSEGNATO .'
          await this.$refs.msgModal.show(msg,{title:'ATTENZIONE !'},1)        
          // return

        }

       

        this.$emit('update',item.productId)
        
        
    },
   
  
    async getData()
    {
        this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'})      
        const orderId  = this.orderId
        const sp       = 'spOrderProductsInProgress'  
        const payload  = {orderId,sp}
        
         try{
        
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
            this.$refs.msgModal.close()
            this.items       = res.data.recordsets[0]                          
            this.row         = this.items.map(() => false) 
            this.saved_items = this.items           
            return this.items

          
          }catch(err)
          {
            //this.$refs.msgModal.close()
            this.$refs.msgModal.show(err.message,{},3)
            return []
            
          }  
       
    },







   
    getDataToPrint(item,type) 
      {
        


        let sp       = {'sp' : 'spProductBarcodeStockWareHouse'}             
        const data     = {'productId' : item.productId,'orderId':this.orderId}
        if(type == 0)
        {
          sp       = {'sp' :  'spOrderProductBarcodesNew'}
        }
        if(type == 1)  
        {
          sp = { 'sp' : 'spLastStockMovementProductBarcodes'}     
        }
                     
        const json  = Object.assign(data, sp)
        return new  Promise( async (resolve, reject)  =>  {
        
        await api.post(json).then(res => {
          
          if(res.status==200)
            {
               resolve(res.data.recordsets[0])   
            }
           else if(res.status == 500)
           {
                
                
                console.log(res.data)                    
           } 
           else
            { 
                
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          //this.spinner = false
        });          
        
        })

      }, 
    
    
    
  }
};
</script>
<style scoped>




h4 {
  font-family   : 'Roboto Condensed';
  font-size     : 20px;
}
h5,p {
  font-family   : 'Roboto Condensed';
  font-size     : 16px;
}


.my-custom-scrollbar {
  height: 600px;
  overflow-y: auto;
}

.table-wrapper-scroll-y {
  display: block;
}



/* tutti gli header */


.table thead th {
  
  background  : #5c8fb1;
  color       : white;

}

/* prima riga */
.table thead tr:nth-child(1) th {
   position    : sticky;
  top: 0;
  z-index: 20;
}

/* seconda riga */
.table thead tr:nth-child(2) th 
{
  top         : 70px;   /* altezza reale della prima riga */
  z-index     : 19;
  color       : rgb(16, 16, 15) !important;
  background  : #a9cbe2;
  position    : sticky;
}



.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-weight  : bold;
    font-size    : 18px;
    background   : whitesmoke;
    color        : green;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;
    

 }





.table th:first-child
{
  border-radius : 0 0 0 10px;
}



.table th:last-child
{
  border-radius : 0 10px 0 0;  
}

.form-check-label {
  cursor: pointer;
}

.editOrder{
  font-size: medium;
}

.table {
  border-collapse: separate;
}


.table,
.table th, 
.table td
{
  border-color: #3b28a7 !important;
}


.hover-row:hover i.fa-trash,
.hover-row:hover i.fa-database,
.hover-row:hover i.fa-edit
 {
    color: white !important;   /* nuovo colore */
    transition: color 0.3s ease;
}

</style>